<div class="main-container no-select">
    <div class="ltms-tabs">
        <!-- <span class="ltms-tab" (click)="onClickingNavigation('summary')" [ngClass]="{'ltms-active-tab': activeTab ==='summary' || !activeTab}">Summary</span> -->
        <span class="ltms-tab" *ngIf="tabVisisblity.trends && showTrendsTab" (click)="onClickingNavigation('trends')" [ngClass]="{'ltms-active-tab': activeTab === 'trends' || !activeTab}">Trends</span>
        <span class="ltms-tab" *ngIf="tabVisisblity.questions" (click)="onClickingNavigation('questions')" [ngClass]="{'ltms-active-tab': activeTab === 'questions'}">Questions</span>
        <span class="ltms-tab" *ngIf="tabVisisblity.custom" (click)="onClickingNavigation('custom')" [ngClass]="{'ltms-active-tab': activeTab === 'custom'}">Custom</span>
        <span class="ltms-tab" *ngIf="tabVisisblity.quickinsights" (click)="onClickingNavigation('quickinsights')" [ngClass]="{'ltms-active-tab': activeTab === 'quickinsights'}">Quick Insights</span>
        <span class="ltms-tab" *ngIf="tabVisisblity.comparison && showComparisonTab"  (click)="onClickingNavigation('comparison')" [ngClass]="{'ltms-active-tab': activeTab === 'comparison'}">Comparison</span>
        <!-- <span class="ltms-tab" *ngIf="tabVisisblity.trendstwo"  (click)="onClickingNavigation('trendstwo')" [ngClass]="{'ltms-active-tab': activeTab === 'trendstwo'}">Trends V2</span> -->
        <!-- <div class="customLine"></div> -->
    </div>
    <div *ngIf="queryParams$ | async as params">
        <!-- <div *ngIf="activeTab === 'summary' || !activeTab">
            <app-score-summary></app-score-summary>
        </div> -->
        <div *ngIf="(activeTab === 'trends' || !activeTab) && tabVisisblity.trends">
            <app-score-trends></app-score-trends>
        </div>
        <div *ngIf="activeTab === 'questions' && tabVisisblity.questions">
            <app-score-question></app-score-question>
        </div>
        <div *ngIf="activeTab === 'custom' && tabVisisblity.custom">
            <app-score-custom></app-score-custom>
        </div>
        <div *ngIf="activeTab === 'quickinsights' && tabVisisblity.quickinsights">
            <app-project-score-quick-insights></app-project-score-quick-insights>
        </div>
        <div *ngIf="activeTab === 'comparison' && tabVisisblity.comparison">
            <app-score-comparison></app-score-comparison>
        </div>
        <div *ngIf="activeTab === 'trendstwo' && tabVisisblity.trendstwo">
            <app-score-trends-new></app-score-trends-new>
        </div>
    </div>
</div>